"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardResponseToJSON = exports.DashboardResponseFromJSONTyped = exports.DashboardResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function DashboardResponseFromJSON(json) {
    return DashboardResponseFromJSONTyped(json, false);
}
exports.DashboardResponseFromJSON = DashboardResponseFromJSON;
function DashboardResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'stats': !(0, runtime_1.exists)(json, 'stats') ? undefined : (0, _1.CommunityPoolStatsFromJSON)(json['stats']),
        'participants': !(0, runtime_1.exists)(json, 'participants') ? undefined : (json['participants'].map(_1.CommunityPoolParticipantFromJSON)),
        'invited': !(0, runtime_1.exists)(json, 'invited') ? undefined : (json['invited'].map(_1.CommunityPoolParticipantFromJSON)),
        'eligible': !(0, runtime_1.exists)(json, 'eligible') ? undefined : (json['eligible'].map(_1.EligibleUserFromJSON)),
        'revoked': !(0, runtime_1.exists)(json, 'revoked') ? undefined : (json['revoked'].map(_1.CommunityPoolParticipantFromJSON)),
        'eligibleCount': !(0, runtime_1.exists)(json, 'eligibleCount') ? undefined : json['eligibleCount'],
        'participantsCount': !(0, runtime_1.exists)(json, 'participantsCount') ? undefined : json['participantsCount'],
        'invitedCount': !(0, runtime_1.exists)(json, 'invitedCount') ? undefined : json['invitedCount'],
        'revokedCount': !(0, runtime_1.exists)(json, 'revokedCount') ? undefined : json['revokedCount'],
    };
}
exports.DashboardResponseFromJSONTyped = DashboardResponseFromJSONTyped;
function DashboardResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'stats': (0, _1.CommunityPoolStatsToJSON)(value.stats),
        'participants': value.participants === undefined ? undefined : (value.participants.map(_1.CommunityPoolParticipantToJSON)),
        'invited': value.invited === undefined ? undefined : (value.invited.map(_1.CommunityPoolParticipantToJSON)),
        'eligible': value.eligible === undefined ? undefined : (value.eligible.map(_1.EligibleUserToJSON)),
        'revoked': value.revoked === undefined ? undefined : (value.revoked.map(_1.CommunityPoolParticipantToJSON)),
        'eligibleCount': value.eligibleCount,
        'participantsCount': value.participantsCount,
        'invitedCount': value.invitedCount,
        'revokedCount': value.revokedCount,
    };
}
exports.DashboardResponseToJSON = DashboardResponseToJSON;
